/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse,
  PatchApiV1ExamRevisionLangBotexamlangidActivePathParams,
  PatchApiV1ExamRevisionLangBotexamlangidActive400,
  PatchApiV1ExamRevisionLangBotexamlangidActive401,
  PatchApiV1ExamRevisionLangBotexamlangidActive404,
  PatchApiV1ExamRevisionLangBotexamlangidActive500,
} from "../../types/examRevisionController/PatchApiV1ExamRevisionLangBotexamlangidActiveActive.ts";

function getPatchApiV1ExamRevisionLangBotexamlangidActiveActiveUrl(
  botExamLangId: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["botExamLangId"],
  active: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["active"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/exam/revision/lang/${botExamLangId}/active/${active}` as const,
  };
  return res;
}

/**
 * @description Ativa ou inativa um idioma de prova gerada por IA e todas as suas questões e opções em cascata. Passe 'true' para habilitar e 'false' para desabilitar. Retorna 404 se o idioma não for encontrado. **(Requer Authorization para autenticação)**
 * @summary Habilitar ou desabilitar idioma de prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId/active/:active}
 */
export async function patchApiV1ExamRevisionLangBotexamlangidActiveActive(
  botExamLangId: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["botExamLangId"],
  active: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["active"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ExamRevisionLangBotexamlangidActive400
      | PatchApiV1ExamRevisionLangBotexamlangidActive401
      | PatchApiV1ExamRevisionLangBotexamlangidActive404
      | PatchApiV1ExamRevisionLangBotexamlangidActive500
    >,
    unknown
  >({
    method: "PATCH",
    url: getPatchApiV1ExamRevisionLangBotexamlangidActiveActiveUrl(
      botExamLangId,
      active,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
